const env = (window as any).env;

export const environment = {
  production: true,
  // apiUrl: `https://web:${env.play_port}/api`,
  apiUrl: `https://${env.backend_host}/api`,
  regUrl: '${process.env.REG_URL}'
};
